__turbopack_context__.v({
  "cardBottom": "page-module__E0kJGG__cardBottom",
  "cardFrame": "page-module__E0kJGG__cardFrame",
  "cardInner": "page-module__E0kJGG__cardInner",
  "cardsGrid": "page-module__E0kJGG__cardsGrid",
  "catalogContent": "page-module__E0kJGG__catalogContent",
  "categoryBarLeft": "page-module__E0kJGG__categoryBarLeft",
  "categoryBarRight": "page-module__E0kJGG__categoryBarRight",
  "categoryBlock": "page-module__E0kJGG__categoryBlock",
  "categoryChevron": "page-module__E0kJGG__categoryChevron",
  "categoryCountBadge": "page-module__E0kJGG__categoryCountBadge",
  "categoryDropdownMenu": "page-module__E0kJGG__categoryDropdownMenu",
  "categoryOrnament": "page-module__E0kJGG__categoryOrnament",
  "categoryTitle": "page-module__E0kJGG__categoryTitle",
  "checkpoint": "page-module__E0kJGG__checkpoint",
  "chevronOpen": "page-module__E0kJGG__chevronOpen",
  "clearSearchBtn": "page-module__E0kJGG__clearSearchBtn",
  "cursorDot": "page-module__E0kJGG__cursorDot",
  "cursorRing": "page-module__E0kJGG__cursorRing",
  "dropdownHeader": "page-module__E0kJGG__dropdownHeader",
  "dropdownOption": "page-module__E0kJGG__dropdownOption",
  "dropdownOptionActive": "page-module__E0kJGG__dropdownOptionActive",
  "dropdownOptionCount": "page-module__E0kJGG__dropdownOptionCount",
  "dropdownOptionName": "page-module__E0kJGG__dropdownOptionName",
  "dropdownSlideFade": "page-module__E0kJGG__dropdownSlideFade",
  "emptyState": "page-module__E0kJGG__emptyState",
  "emptySubtitle": "page-module__E0kJGG__emptySubtitle",
  "emptyTitle": "page-module__E0kJGG__emptyTitle",
  "imageContainer": "page-module__E0kJGG__imageContainer",
  "imageOverlay": "page-module__E0kJGG__imageOverlay",
  "itemCard": "page-module__E0kJGG__itemCard",
  "itemImage": "page-module__E0kJGG__itemImage",
  "itemName": "page-module__E0kJGG__itemName",
  "itemOrnament": "page-module__E0kJGG__itemOrnament",
  "langActive": "page-module__E0kJGG__langActive",
  "langInactive": "page-module__E0kJGG__langInactive",
  "langSep": "page-module__E0kJGG__langSep",
  "langToggle": "page-module__E0kJGG__langToggle",
  "lineDecor": "page-module__E0kJGG__lineDecor",
  "lineText": "page-module__E0kJGG__lineText",
  "loginButton": "page-module__E0kJGG__loginButton",
  "main": "page-module__E0kJGG__main",
  "presentationFade": "page-module__E0kJGG__presentationFade",
  "railDot": "page-module__E0kJGG__railDot",
  "railDotActive": "page-module__E0kJGG__railDotActive",
  "scrollCanvas": "page-module__E0kJGG__scrollCanvas",
  "scrollHint": "page-module__E0kJGG__scrollHint",
  "scrollHintHidden": "page-module__E0kJGG__scrollHintHidden",
  "scrollHintLabel": "page-module__E0kJGG__scrollHintLabel",
  "scrollHintMouse": "page-module__E0kJGG__scrollHintMouse",
  "scrollHintWheel": "page-module__E0kJGG__scrollHintWheel",
  "scrollRail": "page-module__E0kJGG__scrollRail",
  "searchBarDocked": "page-module__E0kJGG__searchBarDocked",
  "searchBarHero": "page-module__E0kJGG__searchBarHero",
  "searchBarWrapper": "page-module__E0kJGG__searchBarWrapper",
  "searchDockGroup": "page-module__E0kJGG__searchDockGroup",
  "searchIcon": "page-module__E0kJGG__searchIcon",
  "searchInner": "page-module__E0kJGG__searchInner",
  "searchInput": "page-module__E0kJGG__searchInput",
  "searchSubmitBtn": "page-module__E0kJGG__searchSubmitBtn",
  "searchWordmark": "page-module__E0kJGG__searchWordmark",
  "shopPaperBg": "page-module__E0kJGG__shopPaperBg",
  "shopSection": "page-module__E0kJGG__shopSection",
  "shopSectionInner": "page-module__E0kJGG__shopSectionInner",
  "shopStickyHeader": "page-module__E0kJGG__shopStickyHeader",
  "shopTransitionOverlay": "page-module__E0kJGG__shopTransitionOverlay",
  "stickyCategoryBar": "page-module__E0kJGG__stickyCategoryBar",
  "textHidden": "page-module__E0kJGG__textHidden",
  "textItem": "page-module__E0kJGG__textItem",
  "textOverlay": "page-module__E0kJGG__textOverlay",
  "textVisible": "page-module__E0kJGG__textVisible",
  "toolbarActions": "page-module__E0kJGG__toolbarActions",
  "toolbarFilterMenu": "page-module__E0kJGG__toolbarFilterMenu",
  "toolbarFrame": "page-module__E0kJGG__toolbarFrame",
  "toolbarIconActive": "page-module__E0kJGG__toolbarIconActive",
  "toolbarIconButton": "page-module__E0kJGG__toolbarIconButton",
  "toolbarLangToggle": "page-module__E0kJGG__toolbarLangToggle",
  "topProgress": "page-module__E0kJGG__topProgress",
  "videoBg": "page-module__E0kJGG__videoBg",
  "videoOverlay": "page-module__E0kJGG__videoOverlay",
  "videoWrapper": "page-module__E0kJGG__videoWrapper",
  "wheelDrop": "page-module__E0kJGG__wheelDrop",
});
